export const TOPIC_DISPLAY_LABELS: Record<string, string> = {
  backend: "백엔드",
  "software-engineering": "소프트웨어 엔지니어링",
  "ai-engineering": "AI 엔지니어링",
  "distributed-systems": "분산 시스템",
  realtime: "실시간 시스템",
  java: "Java",
  spring: "Spring",
  "data-consistency": "데이터 일관성",
  "api-design": "API 설계",
  "object-oriented-design": "객체지향 설계",
  "software-design": "소프트웨어 설계",
  "learning-system": "학습 시스템",
};
